import * as React from 'react';
import {
    ScheduledTournamentConfig, SitAndGoConfig, TournamentConstraints, TournamentOperator,
} from '../../../../generated/protocol';
import { Form, FormListener  } from '../../form/Form';
import { FormSubmitError, FormSubmitSuccess } from '../../form/FormFeedback';
import { DeleteButtonModal } from '../../util/DeleteButtonModal';
import { TournamentConfigPanel } from './TournamentConfigPanel';

import { Submit } from '../../form/Submit';

interface Props {
    tournament?: SitAndGoConfig;
    constraints?: TournamentConstraints;
    validationMap?: any;
    formListener?: FormListener<ScheduledTournamentConfig>;
    newTournament?: boolean;
    archive?: () => void;
    restore?: () => void;
    onSuccessClose?: () => void;
}

export class SitAndGoForm extends React.Component<Props, {}> {

    getTopButtons() {

        if (!this.props.newTournament) {
            if (this.props.tournament && this.props.tournament.configuration.archived) {
                return (
                    <div className='page-top-actions'>
                        <DeleteButtonModal label='Restore' className='btn-lg btn-danger'
                                           onDelete={this.props.restore.bind(this)}
                                           description={this.props.tournament.configuration.name}/>
                    </div>
                );
            } else {
                return (
                    <div className='page-top-actions'>
                        <DeleteButtonModal label='Archive' className='btn-lg btn-danger'
                                           onDelete={this.props.archive.bind(this)}
                                           description={this.props.tournament.configuration.name}/>
                    </div>
                );
            }
        } else {
            return <div/>;
        }
    }

    render() {
        return (
            <Form className='form-horizontal' formListener={this.props.formListener} modelObject={this.props.tournament}
                  validationMap={this.props.validationMap}>

                {this.getTopButtons()}

                <TournamentConfigPanel sitAndGo={true} constraints={this.props.constraints}/>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <div className="ibox-title">
                                    <h5>Actions</h5>
                                </div>
                                <FormSubmitError/>
                                <FormSubmitSuccess text='Tournament was updated successfully'
                                                   onClose={() => this.props.onSuccessClose()}/>
                                <div className='form-group'>
                                    <div className='col-sm-10 col-sm-offset-2'>
                                        <Submit className='ladda-button btn-lg btn-primary'>Save Sit And Go</Submit>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/SitAndGoForm.tsx